var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0568 2H7.79695C7.28423 2 6.84278 2.33646 6.74223 2.80388L5.02125 10.8039C4.88814 11.4227 5.39721 12 6.07597 12H11.2176L8.79992 20.9909C8.66209 21.5035 9.07909 22 9.64739 22C9.95423 22 10.2386 21.8503 10.3965 21.6057L18.8451 8.5145C19.2752 7.84797 18.7588 7 17.9227 7H12.2932L13.1115 3.19612C13.2446 2.57732 12.7355 2 12.0568 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltAlt);
export default __webpack_public_path__ + "static/media/bolt-alt.a54db17f07f14107adad28fab7298b9e.svg";
export { ForwardRef as ReactComponent };